<template>
  <div class="head-image">
    <img class="cst" v-show="range == 1" :src="imageUrl" alt="" :width="wd" :height="ht">
    <img class="dft" v-show="range == 2" src="../assets/images/icon-default-head.png" alt="">
    <!--<img class="dft" v-else="range == 2" src="../assets/img/login-left.jpeg" alt="">-->
  </div>
</template>

<script>
  export default {
    props: ['link-url', 'size', 'width', 'height', 'radius'],//shape:,size:
    name: 'head-image',
    data () {
      return {
        range: 0,
        wd: 0,
        ht: 0,
        rds: this.radius || 0,
        sizes: this.size || 0,
        ww: this.width || 0,
        hh: this.height || 0,
        resourceUrl: this.globalData.resourceUrl,
      }
    },
    computed: {
      imageUrl(){
        if (this.linkUrl) {
          if ((this.linkUrl.indexOf('http:') >= 0) || (this.linkUrl.indexOf('https:') >= 0)) {
            return this.linkUrl
          } else {
            return this.resourceUrl + this.linkUrl
          }
        } else {
          return this.linkUrl
        }
      }
    },
    mounted(){
      this.setSize()
    },
    methods: {
      setSize(){
        if (this.sizes) {
          this.ww = this.sizes
          this.hh = this.sizes
          $(this.$el).css('width', this.sizes + 'px').css('height', this.sizes + 'px').css('border-radius', this.rds).css('-webkit-border-radius', this.rds)
        } else {
          $(this.$el).css('width', this.ww + 'px').css('height', this.hh + 'px').css('border-radius', this.rds).css('-webkit-border-radius', this.rds)
        }

        var that = this
        if (this.imageUrl) {
          var img = new Image()
          img.src = this.imageUrl
          this.range = 1
          if (img.complete) {
            if ((that.ww / that.hh) >= (img.width / img.height)) {
              that.wd = that.sizes ? that.sizes : that.ww
              that.ht = that.wd / img.width * img.height
              $(this.$el).find('.cst').css('top', ((that.sizes ? that.sizes : that.hh) - that.ht) / 2 + 'px').css('left', '0px')
            } else {
              that.ht = that.sizes ? that.sizes : that.hh
              that.wd = that.ht / img.height * img.width
              $(that.$el).find('.cst').css('left', ((that.sizes ? that.sizes : that.ww) - that.wd) / 2 + 'px').css('top', '0px')
            }
          } else {
            img.onload = function () {
              if ((that.ww / that.hh) >= (img.width / img.height)) {
                that.wd = that.sizes ? that.sizes : that.ww
                that.ht = that.wd / img.width * img.height
                $(that.$el).find('.cst').css('top', ((that.sizes ? that.sizes : that.hh) - that.ht) / 2 + 'px').css('left', '0px')
              } else {
                that.ht = that.sizes ? that.sizes : that.hh
                that.wd = that.ht / img.height * img.width
                $(that.$el).find('.cst').css('left', ((that.sizes ? that.sizes : that.ww) - that.wd) / 2 + 'px').css('top', '0px')
              }
              img.onload = null
            }
          }
        } else {
          this.range = 2
          var img = $('.head-image > .dft')
          var imgw = img.width()
          var imgh = img.height()
          if ((that.ww / that.hh) >= (imgw / imgh)) {
            that.wd = that.sizes ? that.sizes : that.ww
            that.ht = that.wd / imgw * imgh
            $(that.$el).find('.dft').css('width', that.wd + 'px').css('height', that.ht + 'px').css('top', ((that.sizes ? that.sizes : that.hh) - that.ht) / 2 + 'px').css('left', 0)
          } else {
            that.ht = that.sizes ? that.sizes : that.hh
            that.wd = that.ht / imgh * imgw
            $(that.$el).find('.dft').css('width', that.wd + 'px').css('height', that.ht + 'px').css('left', ((that.sizes ? that.sizes : that.ww) - that.wd) / 2 + 'px').css('top', 0)
          }
          setTimeout(function () {
            var img = $('.head-image > .dft')
            var imgw = img.width()
            var imgh = img.height()
            if ((that.ww / that.hh) >= (imgw / imgh)) {
              that.wd = that.sizes ? that.sizes : that.ww
              that.ht = that.wd / imgw * imgh
              $(that.$el).find('.dft').css('width', that.wd + 'px').css('height', that.ht + 'px').css('top', ((that.sizes ? that.sizes : that.hh) - that.ht) / 2 + 'px').css('left', 0)
            } else {
              that.ht = that.sizes ? that.sizes : that.hh
              that.wd = that.ht / imgh * imgw
              $(that.$el).find('.dft').css('width', that.wd + 'px').css('height', that.ht + 'px').css('left', ((that.sizes ? that.sizes : that.ww) - that.wd) / 2 + 'px').css('top', 0)
            }
          }, 500)
        }
      }
    },
    watch: {
      imageUrl(val){
        this.setSize()
      },
      width(val){
        this.ww = val
        this.setSize()
      },
      height(val){
        this.hh = val
        this.setSize()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .head-image {
    overflow: hidden;
    position: relative;
    background: #fff;
  }

  .head-image > img {
    position: absolute;
    -webkit-transition: all 0s;
    -moz-transition: all 0s;
    -ms-transition: all 0s;
    -o-transition: all 0s;
    transition: all 0s;
  }

</style>



// WEBPACK FOOTER //
// src/components/HeadImage.vue